// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as RaiseTicketRepoConfig from "./RaiseTicketRepoConfig.bs.js";

var dummyRaiseTicketInfo = {
        "caller_number": "0000000000",
        "msisdn": "0000000000000",
        "crn": "CRN00000000",
        "location": "Surat",
        "order_stage": "Post End Job",
        "raised_by": "Customer",
      };

var dummyRaiseTicketIssues = {
        "issues": [
          {
            "issue_name":"Behaviour Issue",
            "issue_comment_required":true
          },
          {
            "issue_name":"Cancel Request/Status",
            "issue_comment_required":false
          },
          {
            "issue_name":"Covid-19 Insurance Query",
            "issue_comment_required":false
          },
          {
            "issue_name":"Details Update Request",
            "issue_comment_required":false
          },
          {
            "issue_name":"Discount And Coupon",
            "issue_comment_required":false
          },
          {
            "issue_name":"Distance Fare",
            "issue_comment_required":true
          },
          {
            "issue_name":"Dry Run Incentive",
            "issue_comment_required":true
          },
          {
            "issue_name":"Fare Related Inquiry",
            "issue_comment_required":true
          }
        ]
      };

var dummyRaiseTicketActions = {
        "actions":[
          {
            "action_name":"Educated/Convinced",
            "action_comment_required":false
          },
          {
            "action_name": "Penalized/Suspended/Blacklist",
            "action_comment_required":true
          },
          {
            "action_name": "Goodwill Request/Manual Fare Adjustment",
            "action_comment_required":false
          },
          {
            "action_name": "Order Cancel",
            "action_comment_required":false
          },
          {
            "action_name":"Waypoint Added",
            "action_comment_required":false
          },
          {
            "action_name":"Agent Error",
            "action_comment_required":false
          },
          {
            "action_name":"Escalate To",
            "action_comment_required":false
          }
        ]
      };

var dummyRaiseTicketResponse = {
          "ticket_id": "1234",
          "message": "Ticket created successfully",
        };

function raiseTicket(_ticket, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyRaiseTicketResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(RaiseTicketRepoConfig.CreateTicketResponseConverter.execute, result);
                        });
            });
}

function fetchTicketInfo(_crn, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyRaiseTicketInfo
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(RaiseTicketRepoConfig.TicketInfoResponseConverter.execute, result);
                        });
            });
}

function fetchTicketIssues(_orderStage, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyRaiseTicketIssues
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(RaiseTicketRepoConfig.TicketIssuesResponseConverter.execute, result);
                        });
            });
}

function fetchTicketActions(_orderStage, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyRaiseTicketActions
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(RaiseTicketRepoConfig.TicketActionsResponseConverter.execute, result);
                        });
            });
}

var RaiseTicketRepo = {
  dummyRaiseTicketInfo: dummyRaiseTicketInfo,
  dummyRaiseTicketIssues: dummyRaiseTicketIssues,
  dummyRaiseTicketActions: dummyRaiseTicketActions,
  dummyRaiseTicketResponse: dummyRaiseTicketResponse,
  raiseTicket: raiseTicket,
  fetchTicketInfo: fetchTicketInfo,
  fetchTicketIssues: fetchTicketIssues,
  fetchTicketActions: fetchTicketActions
};

export {
  RaiseTicketRepo ,
  
}
/* RaiseTicketRepoConfig Not a pure module */
